<div
  *ngIf="fieldLayout('common')"
  class="bl-display--flex bl-margin-bottom--8 review-wrap-width common"
  [id]="fieldSummary?.field?.id"
  [attr.data-automation-id]="automationId"
>
  <span class="bl-col-{{ getData?.columns?.left || 6 }} bl-padding-x--0 common-label" [innerHTML]="getData.label"></span>
  <span class="bl-col-{{ getData?.columns?.right || 6 }} bl-padding-left--24 ">
    <span
      *ngIf="fieldSummary?.field?.config?.type == 'input-obfuscate' || fieldSummary?.field?.config?.type == 'input-mask'; else normalValue"
    >
      <span [innerHTML]="getData.data || (fieldSummary?.field?.required ? '&#8212;' : optionalReviewFieldText)"></span>
      <span>{{ fieldSummary?.field?.config?.postfix || '' }}</span>
    </span>
    <ng-template #normalValue>
      <span
        [innerHTML]="
          getData.data && fieldSummary?.field?.config?.mask
            ? (getData.data?.toString() | mask : fieldSummary?.field?.config?.mask)
            : getData.data?.toString() || (fieldSummary?.field?.required ? '&#8212;' : optionalReviewFieldText)
        "
      ></span>
      {{ fieldSummary?.field?.config?.postfix || '' }}
    </ng-template>
  </span>
</div>

<div
  *ngIf="fieldLayout('long-questions')"
  class="bl-display--flex bl-align-items--left bl-margin-bottom--16 long-questions"
  [id]="fieldSummary?.field?.id"
  [attr.data-automation-id]="automationId"
>
  <div class="bl-col-sm-2 bl-col-lg-1 bl-col-md-1 bl-padding-x--0" [innerHTML]="getData.labelCount"></div>
  <div class="bl-col-8 bl-padding-x--0 margin" [innerHTML]="getData.label"></div>
  <div
    class="bl-col-sm-2 bl-col-lg-3 bl-col-md-3 bl-padding-left--24"
    [innerHTML]="
      getData.data && fieldSummary?.field?.config?.mask
        ? (getData.data?.toString() | mask : fieldSummary?.field?.config?.mask)
        : getData.data?.toString() || (fieldSummary?.field?.required ? '&#8212;' : optionalReviewFieldText)
    "
  ></div>
  {{ fieldSummary?.field?.config?.postfix || '' }}
</div>

<div
  *ngIf="fieldLayout('noLabel')"
  class="bl-display--flex bl-margin-bottom--8 review-wrap-width no-label"
  [id]="fieldSummary?.field?.id"
  [attr.data-automation-id]="automationId"
>
  <span class="bl-col-{{ getData?.columns?.left || 6 }} bl-padding-x--0 ">
    <div
      [innerHTML]="
        getData.data && fieldSummary?.field?.config?.mask
          ? (getData.data?.toString() | mask : fieldSummary?.field?.config?.mask)
          : getData.data?.toString() || (fieldSummary?.field?.required ? '&#8212;' : optionalReviewFieldText)
      "
    ></div>
    {{ fieldSummary?.field?.config?.postfix || '' }}
  </span>
</div>
